import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import ConfirmCheckOutOrIn from './ConfirmCheckoutCheckin';

const ItemDetailsDialog = ({
  open,
  onClose,
  dialogType,
  selectedRowData,
  userRole,
  handleReservationCall,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {dialogType === 'checkOut' ? 'Check Out Details' : 'Check In Details'}
      </DialogTitle>
      <DialogContent>
        {selectedRowData && (
          <div>
            {Object.entries(selectedRowData).map(([key, value]) => (
              <div key={key} style={{ margin: '10px 0' }}>
                <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{" "}
                {value === null || value === undefined ? "N/A" : value.toString()}
              </div>
            ))}
          </div>
        )}
        {userRole !== "ROLE_STUDENT" && (
          <ConfirmCheckOutOrIn 
            type={dialogType} 
            data={selectedRowData}
            handleReservation={handleReservationCall}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItemDetailsDialog;